import type * as React from 'react';

import type { NodeProps } from '@xyflow/react';
import type { Node } from '@xyflow/react';

import type { BaseNodeData, NodeDefinition } from '../../types';

import { ApprovalConfig } from './ApprovalConfig';
import { ApprovalNode, approvalVisualDefinition } from './ApprovalNode';
import {
  ApprovalConfigType,
  defaultApprovalConfig,
  validateApprovalConfig,
  getApprovalPreviewText,
} from './schema';

export { ApprovalNode } from './ApprovalNode';
export { ApprovalConfig } from './ApprovalConfig';
export type { ApprovalConfigType } from './schema';

export const approvalDefinition: NodeDefinition<ApprovalConfigType> = {
  ...approvalVisualDefinition,
  category: 'flow',
  paletteGroup: 'Flow Control',

  NodeComponent: ApprovalNode as unknown as React.ComponentType<
    NodeProps<Node<BaseNodeData>>
  >,
  ConfigComponent: ApprovalConfig,

  defaultConfig: () => ({ ...defaultApprovalConfig }),
  validateConfig: validateApprovalConfig,

  getPreviewText: getApprovalPreviewText,
};
